import "./../styles.scss";

import { LoadingOutlined } from "@ant-design/icons";
import { Menu, Select } from "antd";
import { notification, Pagination, Spin } from "antd";
import { Delete } from "components/icons";
import { Field, Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import Modal from "react-modal";
import { useOutletContext } from "react-router-dom";
import { convertIsoDateToStandardFormat } from "utils/date";
import UploadCSVModal from "views/Configuration/partials/UploadCSVModal";

import AccessControl from "../../../components/common/AccessControl/accessControl";
import ManageAccess from "../../../components/common/ManageAccess/manageAccess";
import DeleteModal from "../../../components/common/Modals/component";
import CloseModal from "../../../components/icons/CloseModal";
import DeleteIcon from "../../../components/icons/DeleteIcon";
import amplitude from "../../../externals/amplitude";
import { addPlayerValidation } from "../../../utils/validations";

const { Option } = Select;
var limit = 20;
const antIcon = <LoadingOutlined style={{ fontSize: 30, color: "#000", align: "center" }} spin />;
const AddPlayer = (props) => {
  const firstRef = useRef(true);
  const {
    loder,
    addTagThroughCSV,
    setSearch,
    setCount,
    count,
    search,
    setLoder,
    settingsRecordsPerPage,
    getAllTagsById,
    deleteTagsById,
    addEvent,
    selectedCategories,
    getAllCategory,
    id,
    getEntityTypes,
    ENTITY_TYPE,
    syncTv2PlayerData,
  } = props;
  const [modalIsOpen, setIsOpen] = useState(false);
  const [editModalIsOpen, setEditModalIsOpen] = useState(false);
  const [event, setEvent] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [playersData, setPlayersData] = useState([]);
  const [delmodalOpen, setDeleteModalOpen] = useState(false);
  const [playerLoder, setPlayerLoder] = useState(false);
  const [csvmodalIsOpen, setcsvIsOpen] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [selectCategory, setSelectCategory] = useState("");

  const { user, clientSetting, entityId } = useOutletContext();
  const [getCategorys, setCategorys] = useState([]);

  useEffect(() => {
    setSearch("");
    if (getCategorys?.length) {
      callPlayerApi(getCategorys?.[0]?.name);
      setEvent(getCategorys?.[0]?.name);
      setSelectCategory(getCategorys?.[0]?.name);
    }
  }, [getCategorys, user]);

  const tableAction = (data) => (
    <Menu
      items={[
        {
          label: (
            <a
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                delOpen(data);
              }}
            >
              <DeleteIcon />
              <span>Delete</span>
            </a>
          ),
          key: "0",
          // disabled: data?.organizationId !== organizationId,
        },
      ]}
    />
  );

  const delOpen = (pname) => {
    setDeleteId(pname);
    setDeleteModalOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const editClose = () => {
    setEditModalIsOpen(false);
    setInitialState({ ...initialState, playerName: "", jerseyNumber: "" });
  };

  const delclose = () => {
    setDeleteModalOpen(false);
  };

  const deletePlayerModel = async () => {
    setPlayerLoder(true);
    const { value } = await deleteTagsById({
      _id: deleteId?._id,
      entityId: id,
    });
    if (value.success) {
      notification["success"]({ message: "Player Delete Successfully" });
    } else {
      notification["error"]({ message: "Something Went Wrong" });
    }
    callPlayerApi(event);
    handlePageChange(1);
    setPlayerLoder(false);
    delclose();
    amplitude.logEvent("player_deleted", { sport: event });
  };

  const [initialState, setInitialState] = useState({
    event: "",
    playerName: "",
  });

  const openModal = () => {
    setInitialState({ ...initialState, event: event });
    setIsOpen(true);
    amplitude.logEvent("add_player_clicked");
  };

  const handlePageChange = (current) => {
    setActivePage(current);
    amplitude.logEvent("player_pagination", { page: current });
  };
  const handleSubmit = async ({ event, playerName }) => {
    const categoryId = getCategorys && getCategorys.filter((data) => data.name == event);

    const { value } = await addEvent({
      name: playerName,
      category: categoryId[0]?.name,
      tagType: "player",
      entityId: id,
      createdBy: user?._id,
    });
    if (value?.success) {
      notification["success"]({ message: "Players added successfully!" });
      callPlayerApi(event);
    } else {
      notification["warning"]({ message: value?.message || "Something Went Wrong!" });
    }
    // if(value)
    closeModal();
    amplitude.logEvent("player_added", { sport: event, name: playerName });
  };

  const openCSVModal = () => {
    setcsvIsOpen(true);
    amplitude.logEvent("upload_event_csv_clicked");
  };
  const closeCSVModal = () => {
    setcsvIsOpen(false);
  };
  const onFileDrop = async (files) => {
    let data = new FormData();
    data.append("file", files[0]);
    data.append("entityId", id);

    //call api here
    const { value } = await addTagThroughCSV(data);
    value.success
      ? notification[value?.warning ? "warning" : "success"]({
          message: value?.warning ? value?.warning : "Players added successfully!",
        })
      : notification["error"]({ message: value.message });
    setcsvIsOpen(false);
    callPlayerApi(event);
    amplitude.logEvent("event_csv_uploaded");
  };

  //handle input search
  const onChangeSearch = async (e) => {
    setSearch(e.target.value);
    setCount(count + 1);
  };

  //call Api after input search
  const callPlayerApi = async (event) => {
    setEvent(event);
    setLoder(true);
    const categoryId = (await getCategorys) && getCategorys?.filter((data) => data.name == event);
    if (categoryId && categoryId.length > 0) {
      const payload = {
        category: categoryId[0]?.name,
        tagType: "player",
        search,
        entityId: id,
        limit: 20,
        pageNo: activePage,
      };
      const { value } = await getAllTagsById(payload);
      if (value?.success) {
        setPlayersData(value);
      }
      setLoder(false);
    }
  };
  const handleSyncTv2Player = async () => {
    try {
      const data = {
        entityId,
        category: selectCategory,
      };
      const { value } = await syncTv2PlayerData(data);
      if (value?.status) {
        notification["success"]({ message: value.message });
      } else {
        notification["error"]({ message: value.message });
      }
    } catch (error) {
      notification["error"]({ message: error.message });
    }
  };
  //call Api after input search
  useEffect(() => {
    if (firstRef.current) {
      if (event) {
        callPlayerApi(event);
      }
      firstRef.current = false;
      setLoder(false);
    } else {
      const timer = setTimeout(() => {
        if (event) {
          callPlayerApi(event);
        }
        if (search) {
          setActivePage(1);
        }
        setLoder(false);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [count, activePage]);

  const getAllCategorys = async () => {
    if (id) {
      const { value } = await getAllCategory({
        entityId: id,
      });
      if (value?.success) {
        let assignCategories = value?.data?.filter((data) => selectedCategories?.includes(data?.name));
        setCategorys(assignCategories || []);
      }
    }
  };
  useEffect(() => {
    if (selectedCategories) getAllCategorys();
  }, [selectedCategories]);
  useEffect(() => {
    callPlayerApi(selectCategory);
  }, [activePage, selectCategory]);
  const handleSelectCategory = (e) => {
    callPlayerApi(e);
    setActivePage(1);
    setSelectCategory(e);
    setSearch("");
  };
  return (
    <>
      <DeleteModal
        deleteComanModel={deletePlayerModel}
        loder={playerLoder}
        modalIsOpen={delmodalOpen}
        setDeleteModalOpen={setDeleteModalOpen}
        header="Delete"
        content="Are you sure you want to delete?"
      />

      <UploadCSVModal
        csvmodalIsOpen={csvmodalIsOpen}
        closeCSVModal={closeCSVModal}
        loader={loder}
        url={"https://test-fancode.s3.amazonaws.com/tags.csv"}
        onFileDrop={onFileDrop}
      />

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Filter Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        className="modal-dialog react-modal-dialog-xs modal-dialog-centered"
      >
        <div className="modal-content">
          <AccessControl code="add_player" page="organization-profile">
            <div className="react-modal-header">
              <h5 className="react-modal-title">Add Player</h5>
              <button type="button" onClick={closeModal} className="btn btn__default">
                <CloseModal />
              </button>
            </div>
          </AccessControl>
          <Formik initialValues={initialState} validationSchema={addPlayerValidation} onSubmit={handleSubmit}>
            {({ errors, touched, setFieldValue }) => (
              <Form>
                <div className="react-modal-body">
                  <div className="form-container">
                    <div className="field-items mb-4">
                      <label className="form-label">
                        Sports <span className="required">*</span>
                      </label>
                      <div className="form-pop-trigger-block">
                        <Field
                          className="custom-ant-select"
                          name="event"
                          onChange={(value) => setFieldValue("event", value)}
                          component={Select}
                          showSearch
                          dropdownStyle={{ zIndex: 99999999 }}
                          // placeholder="Select Sport"
                          defaultValue={event || "Select Category"}
                        >
                          {getCategorys.length &&
                            getCategorys.map((data, index) => {
                              return (
                                <>
                                  <Option key={data._id} value={data.name}>
                                    {data?.displayName}
                                  </Option>
                                </>
                              );
                            })}
                        </Field>
                        {touched.event && errors.event && <div className="invalid-feedback">{errors.event}</div>}
                      </div>
                    </div>
                    <div className="field-items mb-4">
                      <label className="form-label">
                        Player Name <span className="required">*</span>
                      </label>
                      <Field className="form-control" name="playerName" type="text" placeholder="Enter Player Name" />
                      {touched.playerName && errors.playerName && (
                        <div className="invalid-feedback">{errors.playerName}</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="react-modal-footer">
                  <div className="react-foo-container">
                    <div className="right-btn-block text-center">
                      <button type="button" className="btn btn-white" onClick={closeModal}>
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Add
                        {loder == false ? (
                          ""
                        ) : (
                          <Spin
                            size="large"
                            indicator={<LoadingOutlined style={{ fontSize: 50, color: "#000", marginLeft: 50 }} spin />}
                            className="loader__full"
                          ></Spin>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
      <div className="col-md-12">
        <div className="border-block groups-block">
          <div className="left-block">
            <h4 className="title-sm-t">Player</h4>
          </div>
          <AccessControl code="add_player" page="organization-profile">
            <ManageAccess value={getEntityTypes(id) !== ENTITY_TYPE.WORKSPACES}>
              <div className="right-btn-block">
                <div class="button-container">
                  {clientSetting?.permissions?.isTV2PlayerSync &&
                    clientSetting?.permissions?.isTV2PlayerSync?.TV2PlayerSync &&
                    clientSetting?.permissions?.isTV2PlayerSync?.category.includes(selectCategory) && (
                      <button class="btn btn-primary me-3" onClick={handleSyncTv2Player}>
                        Sync TV2 Players
                      </button>
                    )}
                  <button class="btn btn-white me-3" onClick={openCSVModal}>
                    Upload a CSV file
                  </button>
                  <button class="btn btn-primary" onClick={openModal}>
                    Add Player
                  </button>
                </div>
              </div>
            </ManageAccess>
          </AccessControl>
        </div>
        <br />
        <div>
          <label className="form-label"> Select Category </label>
          <div className="field-items mb-4">
            <Select
              showSearch
              className="custom-ant-select"
              value={event}
              placeholder="Select Sport"
              onChange={(e) => {
                handleSelectCategory(e);
                callPlayerApi(e);
                setSearch("");
                amplitude.logEvent("player_category_selected", { sport: e });
              }}
            >
              {getCategorys.length &&
                getCategorys.map((data, index) => {
                  return (
                    <>
                      <Option key={data?._id} value={data.name}>
                        {data?.displayName}
                      </Option>
                    </>
                  );
                })}
            </Select>
          </div>
        </div>
        <div className="configuration-items-row mt-5 row">
          <div className="row mb-4 justify-content-end">
            <div className="col-md-6">
              <h5 className="title-small mb-0">Added Players</h5>
            </div>
            <div className="col-md-6">
              <div className="page-toolbar-styled-item">
                <input
                  type="text"
                  value={search}
                  onChange={(e) => onChangeSearch(e)}
                  placeholder="Search Players"
                  className="form-control filters-search-control"
                />
              </div>
            </div>
          </div>
          {playersData &&
            playersData?.tag?.map((data) => {
              return (
                <>
                  <div className="col-md-2">
                    <div className="confi-block-col-container configuration-column flex-column gap-0 p-2">
                      {/* <AccessControl code="delete_player" page="configuration">
                        <ManageAccess value={data?.organizationId == entityId}>
                          <Dropdown
                            className=""
                            overlay={tableAction(data)}
                            trigger={["click"]}
                            overlayClassName={"tableActionBlock"}
                            placement={"bottomRight"}
                          >
                            <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                              <TdiVerticalDark />
                            </a>
                          </Dropdown>
                        </ManageAccess>
                      </AccessControl> */}
                      {/* <div className="icon-block">
                        <VideoGroup />
                      </div> */}
                      <div className="confi-block-col">
                        <h4 className="word-break-common">{data?.name}</h4>
                        <h6>{convertIsoDateToStandardFormat(data?.createdAt)}</h6>
                      </div>
                      <div className="action-buttons gap-3">
                        <AccessControl code="delete_player" page="organization-profile">
                          <ManageAccess value={getEntityTypes(id) !== ENTITY_TYPE.WORKSPACES}>
                            <button>
                              <Delete
                                onClick={() => {
                                  delOpen(data);
                                }}
                              />
                            </button>
                          </ManageAccess>
                        </AccessControl>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
        </div>
        <ManageAccess value={!playersData.totalCount > 0}>
          <div className="col-md-12">
            <div className="w-100 text-center py-5">
              <h4>No Data Found!</h4>
            </div>
          </div>
        </ManageAccess>
        <>
          <Pagination
            showSizeChanger={false}
            current={activePage}
            pageSize={settingsRecordsPerPage}
            onChange={handlePageChange}
            total={playersData?.totalCount}
            className="text-center mt-3"
          />
        </>
      </div>
    </>
  );
};

export default AddPlayer;
